import useDebounce from "@/hooks/useDebounce";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

const SearchBarResults = dynamic(() => import("./SearchBarResults"), {
  ssr: false,
});

const SearchForm = ({ setMobileBar = () => false, className }) => {
  const router = useRouter();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 1000);

  const handleSubmit = (e) => {
    e.preventDefault();
    router.push(`/arama-sonuclari?search=${search}`);
  };

  useEffect(() => {
    if (router.pathname === "/ProductCategory") {
      setSearch("");
    }
  }, [router.pathname]);
  return (
    <>
      <div className="sticky lg:static top-0 left-0 z-50">
        <span className="block mb-2 text-2xl font-bold lg:hidden">
          Arama Yap
        </span>
        <form
          onSubmit={handleSubmit}
          className="flex  items-center bg-searchbgColor lg:border-r lg:border-l border-[#DFE6EF] relative"
        >
          <label
            htmlFor="search"
            className="flex items-center gap-2 py-5 px-6 w-[20.125rem]"
          >
            <Image
              src="/icons/search.svg"
              alt="search"
              width={20}
              height={20}
            />
            <input
              type="text"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Villa adı veya kodu ile ara"
              autoComplete="off"
              className="w-full text-xs font-normal leading-normal bg-transparent border-0 shadow-none outline-none text-inputTextColor"
            />
          </label>
        </form>
      </div>
      {debouncedSearch.length > 2 && (
        <SearchBarResults
          setSearch={setSearch}
          debouncedSearch={debouncedSearch}
          setIsOpen={setMobileBar}
          className={className}
          search={search}
        />
      )}
    </>
  );
};

export default SearchForm;
